/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useApplicationOnboardingEnabled() {
  return usePostHogFlag("enable_application_onboarding");
}
